<template>
  <div class="page-order-details">
    <page-loader v-if="!order"></page-loader>
    <transition name="fade">
      <div v-if="order">
        <div class="padded-container">
          <div class="row">
            <div class="small-12 column">
              <h2 class="section-title">{{$t('order.label.order-no')}} {{order.number}}</h2>
            </div>
          </div>
        </div>

        <order-detail-overview :order-number="order.number"
                               :order-ref="order.ref"
                               :order-date="order.date"
                               :order-status="order.status"
                               :order-delivery-from="order.delivery.fromDate"
                               :order-delivery-to="order.delivery.toDate">
        </order-detail-overview>

        <div class="padded-container">
          <div class="row">
            <div class="small-12 column">
              <h2 class="section-title">{{$t('order.label.ordered-items')}} ({{order.orderLines.length}})</h2>
            </div>
          </div>
        </div>
        <ul class="article-list">
          <li is="article-list-item"
              v-for="article in order.orderLines"
              :key="order.number"
              :article-ref="article.ref"
              :article-name="article.name"
              :article-status="article.status"
              :article-ordered-qty="article.orderedQty"
              :article-shipped-qty="article.shippedQty"
              :article-note="article.note"
              :delivery-tracking="article.delivery.tracking"
              :delivery-date="article.delivery.date"
              :delivery-date-is-different="article.delivery.dateIsDifferent"
              :delivery-date-has-changed="article.delivery.dateHasChanged">
          </li>
        </ul>

        <div class="bloc-infos padded-container">
          <div class="row">
            <div class="small-12 medium-6 column no-top-border">
              <order-info-block :block-title="$t('order.label.delivery-address')">
                <p v-if="order.deliveryAddress.lastname" class="no-margin">{{order.deliveryAddress.lastname}}</p>
                <p v-if="order.deliveryAddress.firstname" class="no-margin">{{order.deliveryAddress.firstname}}</p>
                <p v-if="order.deliveryAddress.address1" class="no-margin">{{order.deliveryAddress.address1}}</p>
                <p v-if="order.deliveryAddress.address2" class="no-margin">{{order.deliveryAddress.address2}}</p>
                <p class="no-margin">
                  <span v-if="order.deliveryAddress.zipcode">{{order.deliveryAddress.zipcode}}&nbsp;</span>
                  <span v-if="order.deliveryAddress.city">{{order.deliveryAddress.city}}</span>
                </p>
                <p v-if="order.deliveryAddress.country" class="no-margin">{{order.deliveryAddress.country}}</p>
              </order-info-block>
            </div>
            <div class="small-12 medium-6 column no-right-border">
              <order-info-block :block-title="$t('order.label.billing-address')">
                <p v-if="order.invoiceAddress.lastname" class="no-margin">{{order.invoiceAddress.lastname}}</p>
                <p v-if="order.invoiceAddress.firstname" class="no-margin">{{order.invoiceAddress.firstname}}</p>
                <p v-if="order.invoiceAddress.address1" class="no-margin">{{order.invoiceAddress.address1}}</p>
                <p v-if="order.invoiceAddress.address2" class="no-margin">{{order.invoiceAddress.address2}}</p>
                <p class="no-margin">
                  <span v-if="order.invoiceAddress.zipcode">{{order.invoiceAddress.zipcode}}&nbsp;</span>
                  <span v-if="order.invoiceAddress.city">{{order.invoiceAddress.city}}</span>
                </p>
                <p v-if="order.invoiceAddress.country" class="no-margin">{{order.invoiceAddress.country}}</p>
              </order-info-block>
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-6 column">
              <order-info-block :block-title="$t('order.label.delivery-mode')">
                <p v-if="order.delivery.mode">{{$t('order.label.delivery.'+order.delivery.mode)}}</p>
                <p v-else>{{$t('order.label.delivery.none')}}</p>
              </order-info-block>
            </div>
            <div class="small-12 medium-6 column no-right-border">
              <order-info-block :block-title="$t('order.label.payment-mode')">
                <p v-if="order.payment.mode">{{$t('order.label.payment.'+order.payment.mode)}}</p>
                <p v-else>{{$t('order.label.payment.none')}}</p>
              </order-info-block>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import OrderDetailOverview from 'components/OrderDetailOverview'
  import OrderInfoBlock from 'components/OrderInfoBlock'
  import ArticleListItem from 'components/ArticleListItem'
  import PageLoader from 'components/PageLoader'

  export default {
    name: 'page-order-details',
    computed: {
      order () {
        return this.$store.state.currentOrder
      }
    },
    components: {
      'order-detail-overview': OrderDetailOverview,
      'order-info-block': OrderInfoBlock,
      'article-list-item': ArticleListItem,
      'page-loader': PageLoader
    },
    beforeCreate () {
      this.$store.dispatch('getOrderDetails', this.$route.params.id)
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  .page-order-details {
    .order-detail-overview {
      margin-bottom: 30px;
    }

    ul.article-list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .bloc-infos {
      > .row > .column {
        /* Small only */
        @include breakpoint(small only) {
          &:not(.no-top-border) {
            border-top: 1px solid $grey-50;
          }
        }

        /* Medium and up */
        @include breakpoint(medium) {
          &:not(.no-right-border) {
            border-right: 1px solid $grey-50;
          }
        }
      }

      /* Medium and up */
      @include breakpoint(medium) {
        margin-top: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageOrderDetails.vue?6bb6a7d4